module.exports = __webpack_public_path__ + "img/图6.6bd907be.png";